import * as types from "./constant"

export const getStaffProfile = () => ({
  type: types.GET_STAFF_START,
})
export const getStaffProfileSuccess = payload => ({
  type: types.GET_STAFF_SUCCESS,
  payload,
})
export const getStaffProfileFailed = payload => ({
  type: types.GET_STAFF_FAILED,
  payload,
})

// Attendance API

export const getStaffAttendanceStart = payload => ({
  type: types.GET_STAFF_ATTENDANCE_START,
  payload,
})
export const getStaffAttendanceSuccess = payload => ({
  type: types.GET_STAFF_ATTENDANCE_SUCCESS,
  payload,
})
export const getStaffAttendanceFailed = payload => ({
  type: types.GET_STAFF_ATTENDANCE_FAILED,
  payload,
})

// Timetable of current day

export const getTimeTableStartForStaff = () => ({
  type: types.GET_TIMETABLE_DAYS_REQUEST,
})
export const getTimeTableSuccess = payload => ({
  type: types.GET_TIMETABLE_DAYS_SUCCESS,
  payload,
})
export const getTimeTableFailed = payload => ({
  type: types.GET_TIMETABLE_DAYS_FAIL,
  payload,
})
